import { render } from "./passwordDialog.vue?vue&type=template&id=b36eadda"
import script from "./passwordDialog.vue?vue&type=script&lang=js"
export * from "./passwordDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__